import React from 'react';
import { useTranslation } from 'react-i18next';
import './i18n';
import HeroSection from "./components/HeroSection";
import  OrderForm from "./components/OrderForm";
function App() {
  const { t, i18n } = useTranslation();

  const changeLanguage = (lang) => {
    i18n.changeLanguage(lang);
    document.dir = lang === 'ar' ? 'rtl' : 'ltr';
  };

  return (
    <>
    <HeroSection />
     <OrderForm />
      
    </>
  );
}

export default App;
